
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-watch/video-streaming/google-chromecast",
      function () {
        return require("private-next-pages/how-to-watch/video-streaming/google-chromecast/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-watch/video-streaming/google-chromecast"])
      });
    }
  